module.exports = __webpack_public_path__ + "media/images/bank_images/bancobrasil-746c798d9f9408c3627dfd6a92b3b1b3.png";